import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {StorageService} from '../storage-service/storage.service';
import {RouteConstants} from '../../constants/routes.constants';
import {StorageKeys} from '../../enums/storage.enum';
import {SelectedOrgService} from '../selected-org.service';

@Injectable()
export class HttpInterceptorInterceptor implements HttpInterceptor {
  constructor(private readonly storageService: StorageService, 
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly selectedOrgService: SelectedOrgService,
  ) {}

  handleError = (error: any) => {
    if (error.status === 401 || error.statusCode === 401) {
      this.selectedOrgService.clearAll();
      this.storageService.clearLocalStorage();
      sessionStorage.clear();
      this.router.navigate([RouteConstants.Login]);
    }
    return throwError(() => error);
  };

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.storageService.getDataFromLocalStorage(
      StorageKeys.ACCESS_TOKEN
    );
    const userDetails = this.storageService.getDataFromLocalStorage(
      StorageKeys.SELF_DETAILS
    );
    const apiKey = this.activatedRoute.snapshot.queryParamMap.get('apikey');
    let tempBearerHeader = request.headers.get("tempBearer");
    let sseKeyHeader = request.headers.get("x-amz-server-side-encryption-customer-key");
    let algorithmHeader = request.headers.get("x-amz-server-side-encryption-customer-algorithm");
    let parentDirectoryHeader = request.headers.get("parentDirectory");
    let directoryHeader = request.headers.get("directory");
    let shortUrlHeader = request.headers.get("shortUrl");    
    let headers = new HttpHeaders();
    if (userDetails?.company) {
      headers = headers.set("presentCompany", userDetails.company);
    }
    if (parentDirectoryHeader) {
      headers = headers.set("parentDirectory", parentDirectoryHeader);
    }
    if (directoryHeader) {
      headers = headers.set("directory", directoryHeader);
    }
    if (shortUrlHeader){
      headers = headers.set("shortUrl",shortUrlHeader)
    }
    if(sseKeyHeader && algorithmHeader){
      headers = headers.set("x-amz-server-side-encryption-customer-algorithm", algorithmHeader);
      headers = headers.set("x-amz-server-side-encryption-customer-key", sseKeyHeader);
    }else if (apiKey) {
      headers = headers.set("apikey", apiKey);
    }else if (token || tempBearerHeader) {
      headers = headers.set('Authorization', `Bearer ${tempBearerHeader || token}`);
    }
    request = request.clone({
      headers: headers,
    });
    return next.handle(request).pipe(catchError(this.handleError));
  }
}
